module.exports = __webpack_public_path__ + "static/media/bullet_inactive.fd27294c.svg";